import React from 'react';
import getImageSrcSetSizes from 'Shared/getImageSrcSetSizes';
const bg_config = {
  original: 1920,
  desktop: 1920,
  available: [1280, 1920, 2560, 4096]
};
const bg_src = '/images/codes-promo/juin-decembre/mywo-promo-juin-decembre.jpg';
const [bg_srcset, bg_sizes] = getImageSrcSetSizes(bg_src, bg_config);
export default function DiscountCodeBanner({
  ...props
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: "c-front-page-intro__bg",
    src: bg_src,
    srcSet: bg_srcset,
    sizes: bg_sizes
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-front-page-intro__filter"
  }), /*#__PURE__*/React.createElement("div", {
    className: "c-front-page-intro__discount-banner"
  }, /*#__PURE__*/React.createElement("span", {
    className: "c-front-c-front-page-intro__discount-date"
  }, "Du 11 au 20 juin"), /*#__PURE__*/React.createElement("h1", {
    className: "c-front-page-intro__title"
  }, "-20% de r\xE9duction imm\xE9diate* avec le\xA0code\xA0", /*#__PURE__*/React.createElement("span", {
    className: "c-front-page-intro__discount-code"
  }, "MYWO20"), " ", /*#__PURE__*/React.createElement("span", {
    className: "c-front-page-intro__discount-infos"
  }, "Sur la r\xE9servation d\u2019un espace Lounge du 11 juin au 31 d\xE9cembre"))));
}
